import './SuggestionsOverlay.css';
export var suggestionsList = '_ig3pq54-2-0-1';
export var suggestionsOverlay = '_ig3pq52-2-0-1';
export var suggestionsOverlayWrapper = '_ig3pq51-2-0-1';
export var suggestionsOverlayWrapperContainer = '_ig3pq50-2-0-1';
export var suggestionsScrollContainer = '_ig3pq53-2-0-1';